import { Model } from 'modules/core/lib/mobx-rest'

interface ICompanySettingsVersion {
  [key: string]: number | string | null | undefined
}

class CompanySettingsVersion extends Model<ICompanySettingsVersion> {
  constructor(attr: ICompanySettingsVersion = {}) {
    super(attr)
  }

  static urlRoot() {
    return '/attendance/company_settings_versions'
  }

  static urlCurrent() {
    return `${CompanySettingsVersion.urlRoot()}/current`
  }
}

export default CompanySettingsVersion
